import React from 'react';
import { BillingTableItem } from './types';
import {
  Box,
  Button,
  CloseButton,
  DialogActions,
  DialogContent,
  DialogTitle,
  ThemeProvider,
} from '@ui';
import { SafeTextarea } from './SafeTextarea';
import { ModalCell } from '../common/table/OpenModalColumn';
import { Typography } from '../common/Typography';
import { useUpdatePONumber } from './useUpdatePONumber';
import { CircularProgress } from '../common/CircularProgress';

export type POModalProps = { item: BillingTableItem; onClose: () => void };

export const POModal: React.FC<POModalProps> = ({ item, onClose }) => {
  const { update, setPONumber, isLoading, error, poNumber } = useUpdatePONumber({
    item,
    onSuccess: onClose,
  });

  return (
    <ThemeProvider>
      <DialogTitle>
        Add a PO Number to {item.InvoiceNumber}
        <CloseButton onClick={onClose} />
      </DialogTitle>

      <DialogContent>
        <Typography>
          This PO Number will be visible on the document but{' '}
          <Box fontWeight={700} component='span'>
            no
          </Box>{' '}
          message is sent to our customer service.
        </Typography>
      </DialogContent>

      <DialogContent>
        <SafeTextarea value={poNumber} onChange={setPONumber} />

        {error && (
          <Typography gutterBottom color='error'>
            {error}
          </Typography>
        )}
      </DialogContent>

      <DialogActions>
        <Button variant='outlined' onClick={onClose} disabled={isLoading} size='small'>
          Cancel
        </Button>

        <Button
          disabled={isLoading}
          onClick={update}
          startIcon={isLoading && <CircularProgress size='2rem' />}
          size='small'
        >
          Update
        </Button>
      </DialogActions>
    </ThemeProvider>
  );
};

export const PONumberModalCell: ModalCell<BillingTableItem, string> = ({ row, onClose }) => {
  return <POModal item={row.original} onClose={onClose} />;
};
